<template>
  <div class="video">
      <div class="banner">
      <el-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/banner-video.jpg"
        mode="contain"
      ></el-image>
    </div>
    <div class="top">
      <div class="top-banner">
        <el-carousel  auto-play="4000">
          <el-carousel-item v-for="banner in banners" :key="banner.index">
            <img :src="banner.url" alt="" class="fit-img">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="top-list">
          <div class="top-list-one"></div>
          <div class="top-list-one"></div>
          <div class="top-list-one"></div>
          <div class="top-list-one"></div>
          <div class="top-list-one"></div>
          <div class="top-list-one"></div>
      </div>
    </div>
    <div style="width: 100%; height: 48px"></div>
    <div class="block"></div>
    <div style="width: 100%; height: 48px"></div>
    <div class="block"></div>
    <div style="width: 100%; height: 48px"></div>
    <div class="block"></div>
     <div style="width: 100%; height: 48px"></div>
    <div class="block"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [
        {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newvideo/baking/baking20200703165327.png",
          to: "",
        },
         {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newvideo/baking/baking20200703164337.png",
          to: "",
        },
          {
          url: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newvideo/westfood/westfood20200624.png",
          to: "",
        },
      ],
    };
  },
   mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style lang="less" scoped>
.fit-img{
  width:100%;
  height:300px
}
.video {
  width: 100%;
  min-height: 2150px;
  margin-top: 64px;
}
.top {
  width: 1200px;
  padding: 24px 0;
  margin: auto;
  height: 324px;
}
.top-banner {
  width: 533px;
  height: 300px;
  float: left;
  margin-right: 24px;
  background: #eee;
}
.top-list {
  width: 643px;
  height: 300px;
  float: left;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;  
}
.top-list-one{
  width: 198px;
  height: 138px;
  background: #eee;
  margin-bottom: 24px;  
} 
.block {
  width: 1200px;
  margin: auto;
  height: 400px;
  background: #eee;
}
</style>